const unobfuscate = item => {
    item = decodeURI(item);

    item = item.replace(/d7:{a_/g, '~');
    item = item.replace(/redacted\*L16/g, '_');
    item = item.replace(/Ap0Y\|\^/g, ':');
    item = item.replace(/\[~r2L/g, '{');
    item = item.replace(/%Jx3b\),/g, 'a');

    return JSON.parse(item);
};

export default unobfuscate;
